import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {Placeholder, Paywall} from './placeholder';
import { serverURL } from '../config/urls';
import { useUserProfile } from './user-profile-context';

function withAuth(WrappedComponent, isPaid) {
  const WithAuth = props => {
    const [isLoading, setIsLoading] = useState(true);
    const [isAuthenticated, setIsAuthenticated] = useState(true);
    const navigate = useNavigate();
    const { userProfile, updateUserProfile } = useUserProfile();
    // useEffect(() => {
    //   fetch(serverURL + '/auth/check', {
    //     headers: {
    //       'Authorization': `Bearer ${localStorage.getItem('token')}`
    //     }
    //   })
    //     .then(response => response.json())
    //     .then(data => {
    //       if (!data.isAuthenticated) {
    //         setIsAuthenticated(false);
    //         navigate('/signin');
    //       } else {
    //         setIsAuthenticated(true);
    //         updateUserProfile(data);
    //       }
    //     })
    //     .catch(err => {
    //       navigate('/signin');
    //     })
    //     .finally(() => {
    //       setIsLoading(false);
    //     });
    // }, [navigate]);
    // if (isLoading) return (<Placeholder />);
    // if (isAuthenticated && isPaid && !userProfile.isPremium) return (<Paywall />);
    if (isAuthenticated) return <WrappedComponent {...props} />;
  };

  return WithAuth;
}

export default withAuth;
